<template>
  <v-layout
    v-if="channel === 'email'"
    column
    class="pa-5 rounded-lg border border-solid border-secondary bg-white email-preview"
    :class="`${size}-size`"
    @click="$emit('editPromote')"
  >
    <h4 class="mb-4 text-h6">
      {{ metaData.subject }}
    </h4>

    <v-layout class="mb-7 align-center">
      <img src="~/assets/images/avatar.png" width="40" class="mr-3">
      <p class="mb-0 text-subtitle-1 font-weight-medium">
        Robin Le<span class="ml-1 secondary--text text-subtitle-2 font-weight-regular">via &lt;no-reply@jits.com&gt;</span>
        <br>
        <span class="secondary--text text-subtitle-2 font-weight-regular">to me
          <v-icon size="18" color="#707070">
            arrow_drop_down
          </v-icon>
        </span>
      </p>
    </v-layout>

    <v-layout column class="pa-5 email-content">
      <EReadMore
        v-if="showReadMore"
        class="text-body-1"
        :text="metaData.body"
        :line-clamp="lineClamp"
      />
      <pre v-else class="mb-5 text-body-1" v-html="metaData.body" />
      <ESlider :images="featureImages" />
    </v-layout>
  </v-layout>

  <v-layout
    v-else-if="['fb_post', 'fb_ads'].includes(channel)"
    column
    class="rounded-lg border border-solid border-secondary bg-white facebook-preview"
    :class="`${size}-size`"
    @click="$emit('editPromote')"
  >
    <v-layout column class="ma-5">
      <v-flex class="d-flex align-center mb-3">
        <img src="~/assets/images/avatar.png" width="60" class="mr-3">
        <p class="mb-0 primary--text text-subtitle-1">
          {{ channelName }}
          <br>
          <span class="secondary--text text-body-2">
            {{ today }}
          </span>
        </p>
      </v-flex>
      <EReadMore
        v-if="showReadMore"
        class="text-body-1"
        :text="metaData.body || ''"
        :line-clamp="lineClamp"
        unuse-html
      />
      <pre v-else class="text-body-1">{{ metaData.body }}</pre>
    </v-layout>

    <ESlider :images="featureImages" />

    <v-layout class="px-5 py-3 align-center bg-share-info grey--text text--darken-1">
      <v-layout column>
        <h3 class="mb-1 text-caption font-weight-semibold">
          {{ siteUrl }}
        </h3>
        <h5 class="oneline--text grey--text text--darken-4 text-subtitle-1 font-weight-bold">
          {{ (metaData.settings && metaData.settings.title) || '' }}
        </h5>
        <span class="oneline--text text-subtitle-2 font-weight-regular">
          {{ (metaData.settings && metaData.settings.description) || '' }}
        </span>
      </v-layout>
      <div v-if="metaData.cta" class="flex-0-0 text-subtitle-2 flex-center bg-white btn-cta">
        {{ metaData.cta }}
      </div>
    </v-layout>

    <v-layout class="mt-4 mx-5 pt-4 pb-5 bt-secondary justify-space-around">
      <v-btn
        v-for="(fbIcon, fIdx) in fbIcons"
        :key="fIdx"
        text
        color="#B0B4BC"
        class="text-h6"
      >
        <v-icon :size="size === 'medium' ? '32' : '20'" class="mr-1">
          {{ fbIcon.icon }}
        </v-icon>
        {{ fbIcon.title }}
      </v-btn>
    </v-layout>
  </v-layout>

  <v-layout
    v-else-if="channel === 'twitter'"
    column
    class="rounded-lg border border-solid border-secondary bg-white twitter-preview"
    :class="`${size}-size`"
    @click="$emit('editPromote')"
  >
    <v-layout column class="ma-5">
      <v-flex class="d-flex align-center mb-3">
        <img src="~/assets/images/avatar.png" width="60" class="mr-3">
        <p class="mb-0 text-subtitle-1">
          Saros
          <br>
          <span class="secondary--text text-body-2">@Saros_Finacne</span>
        </p>
      </v-flex>
      <EReadMore
        v-if="showReadMore"
        class="text-body-1"
        :text="metaData.body"
        :line-clamp="lineClamp"
        unuse-html
      />
      <pre v-else class="text-body-1">{{ metaData.body }}</pre>
    </v-layout>

    <v-layout column class="mx-5 pb-5 rounded-xl border border-solid border-secondary overflow-hidden">
      <ESlider :images="featureImages" />
      <h3 class="mx-5 mt-3 mb-1 text-caption font-weight-semibold">
        {{ siteUrl }}
      </h3>
      <h5 class="mx-5 oneline--text grey--text text--darken-4 text-subtitle-1 font-weight-bold">
        {{ (metaData.settings && metaData.settings.title) || '' }}
      </h5>
      <span class="mx-5 oneline--text text-subtitle-2 font-weight-regular">
        {{ (metaData.settings && metaData.settings.description) || '' }}
      </span>
    </v-layout>

    <p class="my-3 mx-5 secondary--text text--time">
      8:31 PM · Dec 28, 2021·Twitter Web App
    </p>

    <v-layout class="mx-5 pt-4 pb-5 bt-secondary">
      <p class="mb-0 mr-10 text-subtitle-2 font-weight-bold">
        15.6k<span class="ml-1 secondary--text font-weight-medium">Retweets</span>
      </p>
      <p class="mb-0 mr-10 text-subtitle-2 font-weight-bold">
        15.6k<span class="ml-1 secondary--text font-weight-medium">Quote Tweets</span>
      </p>
      <p class="mb-0 mr-10 text-subtitle-2 font-weight-bold">
        931<span class="ml-1 secondary--text font-weight-medium">Likes</span>
      </p>
    </v-layout>
  </v-layout>

  <v-layout
    v-else-if="channel === 'seo'"
    column
    class="seo-preview align-center"
    :class="`${size}-size`"
  >
    <v-radio-group
      v-model="previewAs"
      hide-details
      row
      class="mt-0 pt-0 mb-5"
    >
      <v-radio
        :ripple="false"
        on-icon="desktop_windows"
        off-icon="desktop_windows"
        value="mobile"
      />
      <v-radio
        :ripple="false"
        on-icon="phone_iphone"
        off-icon="phone_iphone"
        value="desktop"
      />
    </v-radio-group>

    <v-layout
      column
      class="pa-5 rounded border border-solid border-secondary bg-white rounded-lg preview-card w-full"
      :class="previewAs"
      @click="$emit('editPromote')"
    >
      <v-flex class="mb-4 flex-0-0 feature-image">
        <ESlider :images="featureImages" :height="280" :aspect-ratio="0" />
      </v-flex>
      <v-flex class="d-flex flex-column">
        <p class="mb-1 text-body-2">
          {{ siteUrl }}
        </p>
        <h3 class="mb-1 text-body-1 font-weight-bold">
          {{ (metaData.settings && metaData.settings.title) || '' }}
        </h3>
        <span class="text-body-2 twoline--text">{{ (metaData.settings && metaData.settings.description) || '' }}</span>
      </v-flex>
    </v-layout>
  </v-layout>

  <div
    v-else-if="channel === 'sms'"
    class="position-relative sms-preview"
    :class="`${size}-size`"
    @click="$emit('editPromote')"
  >
    <img src="~/assets/images/phone.png" width="100%">

    <v-layout column class="justify-end overflow-hidden position-absolute">
      <v-skeleton-loader v-bind="attrs" type="list-item-three-line" width="184" />
      <v-skeleton-loader v-bind="attrs" type="list-item-two-line" width="255" />
      <v-layout column class="align-end">
        <v-skeleton-loader v-bind="attrs" type="list-item-two-line" width="184" />
        <pre class="mb-5 pa-3 white--text text-body-2 sms-first-item">
          {{ metaData.body }}
        </pre>
        <v-layout column class="flex-0-0 pa-3 white--text sms-second-item">
          <p class="flex-0-0 mb-2 text-caption">
            {{ metaData.settings && metaData.settings.title }}
          </p>
          <span class="sms-url">{{ siteUrl }}</span>
        </v-layout>
      </v-layout>
    </v-layout>
  </div>
</template>

<script>
import { get } from 'lodash'
import moment from 'moment'
import { s3ProxyFile } from '@/utils/upload-s3'
import ESlider from '@/plugins/components/e-slider.vue'
import EReadMore from '@/plugins/components/e-read-more.vue'

export default {
  name: 'ChannelPreview',

  components: {
    ESlider,
    EReadMore
  },

  props: {
    channel: {
      type: String,
      required: true
    },
    metaData: {
      type: Object,
      default: () => ({})
    },
    size: {
      type: String,
      enum: ['small', 'medium'],
      default: 'medium'
    },
    lineClamp: {
      type: Number,
      default: 0
    }
  },

  data: () => ({
    attrs: {
      class: 'sketeton-item flex-0-0 mb-5',
      boilerplate: true
    },
    fbIcons: [
      { title: 'Like', icon: 'thumb_up' },
      { title: 'Comment', icon: 'mode_comment' },
      { title: 'Share', icon: 'mdi-share' }
    ],
    previewAs: 'desktop',
    showReadMore: false
  }),

  computed: {
    siteUrl() {
      return this.$config.baseUrl
    },
    featureImages() {
      if (Array.isArray(this.metaData.featureImages) && this.metaData.featureImages.length) {
        return this.metaData.featureImages.map(image => ({
          imageUrl: image.imageUrl ? {
            ...image.imageUrl,
            thumb: this.$helpers.get(image, 'imageUrl.origin')
          } : s3ProxyFile(image)
        }))
      }

      return [{ imageUrl: this.$helpers.getOrDefaultStreamCover() }]
    },
    today() {
      return moment().format('MMMM D, YYYY h:mm A')
    },
    channelName() {
      const channels = get(this.metaData, 'socialPublishSettings', [])
      const enabledChannel = channels.find(channel => channel.enabled)
      return get(enabledChannel, 'name', get(channels, '[0].name', get(this.$auth.user, 'profile.fullName')))
    }
  },

  created() {
    this.showReadMore = !!this.lineClamp
  }
}
</script>

<style lang="scss">
.sms-preview {
  &.medium-size {
    max-width: 339px;
  }
  &.small-size {
    max-width: 168px;
  }
  .position-absolute {
    left: 26px;
    right: 26px;
    top: 80px;
    bottom: 109px;
  }
  .sketeton-item {
    border-radius: 16px;
    .v-skeleton-loader__list-item-three-line,
    .v-skeleton-loader__list-item-two-line {
      background-color: #E9E9EB !important;
    }
  }
  .sms-first-item, .sms-second-item {
    border-radius: 16px;
    background: #67C868;
  }
  .sms-first-item {
    width: 229px;
  }
  .sms-second-item {
    width: 266px;
    .sms-url {
      font-size: 10px;
      line-height: 13px;
      opacity: 0.6;
    }
  }
}
</style>

<style lang="scss" scoped>
.medium-size:not(.sms-preview) {
  max-width: 764px;
}
.small-size:not(.sms-preview) {
  max-width: 379px;
}

.email-preview {
  .email-content {
    background-color: #f9f9f9;
    p {
      margin: 0;
    }
  }
}

.facebook-preview {
  .bg-share-info {
    background: #F2F3F5;
  }
  .btn-cta {
    width: 109px;
    height: 44px;
    border: 0.5px solid #EEEEEE;
  }
}

.twitter-preview {
  .text--time {
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.0025em;
  }
}

.seo-preview {
  &.medium-size, &.small-size {
    max-width: 664px;
  }
  .preview-card.mobile {
    width: 375px;
    .feature-image {
      display: none !important;
    }
  }
}
</style>
